import React from 'react';

const UploadList = ({ mode, files, isLocked, onRemove, onRetry, darkMode, theme }) => {
  if (!files?.length) return null;

  if (mode === 'uploaded') {
    return (
      <div className="space-y-2">
        <p className={`text-xs font-semibold ${theme.mutedText}`}>✅ Uploaded Files:</p>
        {files.map((file) => (
          <div
            key={file.id}
            className={`flex justify-between items-center p-2 rounded border ${
              darkMode ? 'bg-gray-800 border-green-800' : 'bg-white border-green-200'
            }`}
          >
            <a
              href={file.file_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium truncate text-blue-600 hover:text-blue-800 hover:underline block"
            >
              {file.name}
            </a>
            {!isLocked && (
              <button
                type="button"
                onClick={() => onRemove(file.id)}
                className="ml-2 text-red-600 hover:text-red-800 font-semibold transition"
              >
                ✕
              </button>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <p className={`text-xs font-semibold ${theme.mutedText}`}>⏳ Pending/Failed Uploads:</p>
      {files.map((file) => (
        <div
          key={file.tempId}
          className={`p-2 rounded border ${
            darkMode ? 'bg-gray-800 border-yellow-700' : 'bg-gray-100 border-yellow-300'
          }`}
        >
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0">
              <p className={`text-sm truncate ${theme.text}`}>{file.name}</p>
              <p className="text-xs text-yellow-600 break-words">
                {file.status === 'uploading'
                  ? 'Uploading...'
                  : file.status === 'failed'
                  ? `Failed: ${file.error || 'Upload failed'}`
                  : 'Queued...'}
              </p>
            </div>

            <div className="flex items-center gap-2">
              {file.status === 'failed' && (
                <button
                  type="button"
                  onClick={() => onRetry(file.tempId)}
                  className="text-xs px-2 py-1 rounded bg-blue-600 text-white hover:bg-blue-700"
                >
                  Retry
                </button>
              )}
              {file.status !== 'uploading' && (
                <button
                  type="button"
                  onClick={() => onRemove(file.tempId)}
                  className="text-red-600 hover:text-red-800 font-semibold transition"
                >
                  ✕
                </button>
              )}
            </div>
          </div>

          {file.status === 'uploading' && (
            <div className="mt-2">
              <div className={`w-full h-2 rounded overflow-hidden ${darkMode ? 'bg-gray-700' : 'bg-gray-300'}`}>
                <div
                  className="h-2 bg-blue-600 transition-all duration-200"
                  style={{ width: `${file.progress || 0}%` }}
                />
              </div>
              <p className="text-[11px] text-blue-600 mt-1">{file.progress || 0}%</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default UploadList;